import getHockeydataInstance from '#lib/hockeydata/hockeydata.js';
import type {
	HDGoalkeeperStats,
	HDPlayerStats,
	HDTeamRosterPlayer
} from '#lib/hockeydata/types/responses/TeamDetails.js';
import { error } from '@sveltejs/kit';
import _ from 'lodash';

export const load = async ({ fetch, params, parent }) => {
	const { season } = await parent();
	const hockeydata = getHockeydataInstance(fetch);

	const team = await hockeydata.getTeamDetails(season, params.teamId);

	if (!team) {
		error(404, 'Team nicht gefunden');
	}

	let players = team.data.teamRoster.map((player) => {
		const playerStats = team.data.playerStats.find((p) => p.id === player.id);
		const goalieStats = team.data.goalkeeperStats.find((p) => p.id === player.id);
		return {
			...playerStats,
			...goalieStats,
			...player
		} as HDTeamRosterPlayer & HDPlayerStats & HDGoalkeeperStats;
	});

	players = _.orderBy(players, ['points', 'playingTime'], ['desc', 'desc']);

	const playersByPosition = _.groupBy(players, 'position');

	return {
		team,
		players,
		playersByPosition,
		standings: await hockeydata.getStandings(season),
		teamImage: await hockeydata.getTeamImageUrl(season, params.teamId)
	};
};
